import type { HeroData } from "./Home.types";

export const heroData: HeroData = {
  
  tagline: "Creating impactful digital experiences",
  jobs: ["Frontend Developer", "Next.js Developer", "React.js Developer"],

};
